<fc-general-modal [baseId]="baseId" [form]="form" [fcModalItemContext]="fcModalItemContext" (cancelForm)="onCancel()" (saveForm)="save()">
  <div [formGroup]="form">
    <mat-tab-group animationDuration="0ms" mat-align-tabs="start" class="tabs-default full-modal-tabs" [disableRipple]="true">
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Demographics</span>
          <mat-badge
            *ngIf="getFormValidationErrors(demographicFormGroup) as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>

        <fc-demographics-tab
          [baseId]="baseId"
          [form]="demographicFormGroup"
          [listItem]="listItem"
          [itemContext]="fcModalItemContext"
          [isSubmitted]="isSubmitted"
        >
        </fc-demographics-tab>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Direct Message</span>
          <mat-badge
            *ngIf="getFormValidationErrors(directMessageFormGroup) as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>
        <h4
          id="{{ baseId }}-address-subtitle"
          translate
        >Direct Addresses</h4>
        <h5
          id="{{ baseId }}-address-subtitle"
          translate
        >Direct Message To Addresses</h5>
        <div class="flex-row-generic">
          <div class="form-group flex-item-three-columns">
            <label
              for="{{ baseId }}-id"
              translate
            >Address</label>
            <input
              disabled
              id="{{ baseId }}-id"
              class="form-control"
            />
          </div>
          <div class="default-checkbox">
            <mat-checkbox id="{{ baseId }}-inactive-checkbox" disabled translate> Default</mat-checkbox>
          </div>
        </div>

      </mat-tab>
    </mat-tab-group>
  </div>
</fc-general-modal>
